import { render, staticRenderFns } from "./formGroupInput.vue?vue&type=template&id=ddb7f6e2"
import script from "./formGroupInput.vue?vue&type=script&lang=js"
export * from "./formGroupInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports